import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
  'Omar Alexander',
  'Carlos Abbott',
  'Miriam Wagner',
  'Bradley Wilkerson',
  'Virginia Andrews',
];

export default function MultiSelectCheckboxSensors({ controllersInfo, variable, setSensorGroup, sensorGroup,completedSystems}) {
  //return list of role names from array of objects where name is found in the role key  
  let completedSystemsRoleName:any = []
  //iterate over completed systems variable key that matches the current variable and
  // iterate over the controllers_info object and return the role key's value
  completedSystems.map((system) => {if(system.variable  === variable) system.sensors.map((sensor:any) => {completedSystemsRoleName.push(sensor.name);})})
  //do the same thing but for sensorGroup
  let sensorGroupRoleName:any = []
  sensorGroup.map((system) => {if(system.variable  === variable) system.sensors.map((sensor:any) => {sensorGroupRoleName.push(sensor.name);})})
const [options, setOptions] = React.useState<string[]>(sensorGroupRoleName);

  const handleChange = (event: SelectChangeEvent<typeof sensorGroupRoleName>) => {
    const {target: { value },} = event;
    console.log('here we are, ', value)
    //iterate over completed systems variable key that matches the current variable and return the
    // controllers_info oject that's role key matches the value of one of the options/
    let currentCompletedSystem:any;
    completedSystems.map((system) => {if(system.variable  === variable) currentCompletedSystem=system;})
    let sensorsList:any = []
    // currentCompletedSystem.controllers_info.map((controller) => {console.log(controller.role===value);if(controller.role === value) controllersInfo.push(controller);})
    //In the variable currentCompletedSystem.controllers_info, push the object where the role key matches the value of one of the options from value
    // value is an array of strings
    value.map((option) => {currentCompletedSystem.sensors.map((sensor) => {if(sensor.name === option) sensorsList.push(sensor);})})
    let tempSensorGroup = sensorGroup
    //sensorGroup is the same structure as completedSystems but it's a state variable I want to update the controllers_info key with the controllersInfoList 
    //using the variable key to find the correct object
    let updated = false
    tempSensorGroup.map((system) => {if(system.variable === variable){ system.sensors = sensorsList; updated = true;}})
    if(updated === false) tempSensorGroup.push(currentCompletedSystem)
    setSensorGroup(tempSensorGroup)



    setOptions(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value,
    );
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: 300 }}>
        <InputLabel id="demo-multiple-checkbox-label">Tag</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={options}
          onChange={handleChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => selected.join(', ')}
          MenuProps={MenuProps}
        >
          {completedSystemsRoleName.map((name) => (
            <MenuItem key={name} value={name}>
              <Checkbox checked={options.indexOf(name) > -1} />
              <ListItemText primary={name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}